
  import RatingList from '@/components/sections/RatingList.vue';
  import RatingForm from '@/components/sections/RatingForm.vue';

  export default {
    components: {
      RatingList,
      RatingForm,
    },
    props: {
      grade: {
        type: Number,
        required: false,
        default: 0,
      },
      showList: {
        type: Boolean,
        required: false,
        default: true,
      },
      color: {
        type: String,
        default: 'primaryYellow',
      },
    },
    data() {
      return {
        dialog: false,
      };
    },
    methods: {
      scrollToForm: function () {
        document
          .getElementById('pb-rating-form')
          .scrollIntoView({behavior: 'smooth'});
      },
    },
  };
